import { Fragment, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types"
import { map, compact } from "lodash"
import { List, ListItemButton, ListItemText, Divider } from "@mui/material"

export default function ExperimentsList({ openSearch, trackExperimentTypeSelection, close, account, toggleSaveExperiment, portfolio, isOpPro }) {
  const navigate = useNavigate()
  const handleOpenSearch = () => {
    openSearch()
    trackExperimentTypeSelection("search")
  }

  const handleGoToRebalance = () => {
    close()
    trackExperimentTypeSelection("simulation")
    navigate(`/${account}/p/${portfolio}/rebalance/simulator`)
  }

  const handleGoToOptimize = () => {
    close()
    trackExperimentTypeSelection("optimization")
    navigate(`/${account}/p/${portfolio}/rebalance/optimizer`)
  }

  const handleToggleSaveExperiment = () => {
    trackExperimentTypeSelection("upload")
    toggleSaveExperiment()
  }

  const options = compact([
    !isOpPro && {
      primary: "Optimize Portfolio",
      secondary: "Adjust constraints and find optimal portfolio using efficient frontier",
      click: handleGoToOptimize,
      id: "add-optimization-experiment",
    },
    {
      primary: "Simulate Trades",
      secondary: "Manually adjust position sizes and/or add additional securities with real-time risk & exposure updates",
      click: handleGoToRebalance,
      id: "add-simulation-experiment",
    },
    {
      primary: "Search for existing experiments",
      secondary: "Browse through previously saved experiments",
      click: handleOpenSearch,
      id: "add-existing-experiment",
    },
    {
      primary: "Upload experiment portfolio",
      secondary: "Select .csv, .xlsx file that correspond to an experiment",
      click: handleToggleSaveExperiment,
      id: "add-upload-experiment",
    },
  ])

  const listItems = useMemo(() => map(options, (option, index) =>
    <Fragment key={`option-${index}`}>
      <Divider component="li" />
      <ListItemButton id={option.id} onClick={option.click}>
        <ListItemText primary={option.primary} secondary={option.secondary} />
      </ListItemButton>
    </Fragment>),
  [options])

  return <List className="experiments-list">
    {listItems}
  </List>
}

ExperimentsList.propTypes = {
  openSearch: PropTypes.func.isRequired,
  trackExperimentTypeSelection: PropTypes.func.isRequired,
  close: PropTypes.func,
  account: PropTypes.string.isRequired,
  toggleSaveExperiment: PropTypes.func.isRequired,
  portfolio: PropTypes.string.isRequired,
  isOpPro: PropTypes.bool.isRequired,
}
